import { render } from "./SettingsPrivacyPolicyPage.vue?vue&type=template&id=a6de744e&ts=true"
import script from "./SettingsPrivacyPolicyPage.vue?vue&type=script&lang=ts"
export * from "./SettingsPrivacyPolicyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__